import type { Locale } from '@susu/headless-commerce/config/locale'
import type { Configurator } from '@susu/headless-commerce/features/configurator/domain/Configurator/Configurator'
import type { Option } from '@susu/headless-commerce/features/configurator/domain/Option/Option'
import {
  getLocationIdValue,
  getURLTrackingValue,
} from '@susu/headless-commerce/features/configurator/utils/getURLTrackingValue'
import type { CountryConfiguration } from '@susu/headless-commerce/types/CountryConfiguration'
import type { PageType } from '@susu/headless-commerce/types/PageType'
import { trackEvent } from '@susu/headless-commerce/utils/tracking/tracking'
import { isNull } from '@susu/null'
import { isUndefined } from '@susu/undefined'

export type TrackFinalStepClickProps = {
  country: CountryConfiguration
  locale: Locale
  pageType: PageType
  configurator: Configurator
  option: Option
}

export const trackFinalStepClick = async ({
  country,
  locale,
  pageType,
  configurator,
  option,
}: TrackFinalStepClickProps) => {
  if (isUndefined(configurator.selectedOption.value)) {
    return
  }

  const currentConfirmionProductId =
    configurator.selectedOption.value.product.value.id.value
  if (
    isUndefined(currentConfirmionProductId) ||
    isNull(currentConfirmionProductId)
  ) {
    return
  }

  let eventLocation = 'configurator'
  eventLocation += `_${option.step.value.name.value}`

  await trackEvent({
    segment: {
      event: 'finalStepClicked',
      enrichProps: {
        country,
        locale,
      },
      properties: {
        eventCategory: 'configurator_interactions',
        eventLabel: '',
        eventLocation: eventLocation,
        locationId: getLocationIdValue(
          new URL(window.location.href),
          option.step.value.name.value,
        ),
        pageType: pageType,
        url: getURLTrackingValue(
          new URL(window.location.href),
          option.step.value.name.value,
        ),
      },
    },
  })
}
